import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeProps as _normalizeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled"]

import SvgIcon from "./SvgIcon/SvgIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SharedButtonOnlyIcon',
  props: {
    type: { default: "button" },
    disabled: { type: Boolean },
    iconName: {},
    iconSize: { default: "5" },
    dataTestName: { default: "" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _normalizeProps({
    class: ["inline-flex h-11.5 w-11.5 select-none items-center justify-center whitespace-nowrap rounded-full align-top text-sm outline-none focus-visible:border-2 focus-visible:border-black-primary disabled:cursor-not-allowed", { 'text-gray-50': _ctx.disabled }],
    type: _ctx.type,
    disabled: _ctx.disabled,
    [_ctx.dataTestName || ""]: '',
    style: {"-webkit-tap-highlight-color":"rgba(0, 0, 0, 0)"}
  }), [
    _createVNode(SvgIcon, {
      class: _normalizeClass([`h-${_ctx.iconSize} w-${_ctx.iconSize}`, { 'text-gray-40': _ctx.disabled }]),
      "icon-name": _ctx.iconName
    }, null, 8, ["class", "icon-name"])
  ], 16, _hoisted_1))
}
}

})